import React from 'react';
import { WT_TOKENS } from '../../warm-transfer/config';

export interface WarmTransferDetailEmptyProps {
  allQuiet: boolean;
}

export function WarmTransferDetailEmpty({ allQuiet }: WarmTransferDetailEmptyProps) {
  return (
    <div
      className="wt-fade-up wt-d-2 relative flex min-w-0 flex-1 flex-col items-center gap-[22px] overflow-hidden rounded-2xl border border-[var(--cream-2)] bg-[var(--cream-1)] px-8 py-[72px] pb-16 text-center shadow-[var(--sh-1)]"
    >
      <div className="wt-aurora opacity-[0.35]" />
      <div className="wt-aurora-2 opacity-[0.35]" />

      <div className="relative z-[1] flex flex-col items-center gap-[22px]">
        <div
          className="relative flex items-center justify-center"
          style={{ width: 120, height: 120 }}
        >
          <div className="wt-listening-ring" style={{ animationDelay: '0s' }} />
          <div className="wt-listening-ring" style={{ animationDelay: '1.07s' }} />
          <div className="wt-listening-ring" style={{ animationDelay: '2.13s' }} />
          <div
            className="relative z-[3] rounded-full"
            style={{
              width: 12,
              height: 12,
              background: WT_TOKENS.iriDot,
              boxShadow: `0 0 14px ${WT_TOKENS.greenSoft}, 0 0 28px ${WT_TOKENS.greenWash}`,
            }}
          />
        </div>
        <div>
          <h2 className="m-0 mb-2 text-[28px] font-medium leading-[1.15] tracking-[-0.03em] text-[var(--ink-0)]">
            {allQuiet ? (
              <>
                Elva hasn&apos;t needed <span className="wt-serif text-[34px] font-normal">a hand</span>.
              </>
            ) : (
              'Select a transfer'
            )}
          </h2>
          <p className="m-0 max-w-[44ch] text-[14px] leading-[1.6] tracking-[-0.005em] text-[var(--ink-1)]">
            {allQuiet
              ? "She's handling everything solo right now. Patients who need a human will appear here."
              : 'Pick a transfer from the rail to see what Elva learned and pick up the call.'}
          </p>
        </div>
      </div>
    </div>
  );
}
